
<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from '@shared_components/base_index.vue';
import New from './new.vue';
import Edit from './edit.vue';
import Delete from './delete.vue';

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      // tableHeaders: [],
      maskFields: [
        { field: 'percent', mask: 'percentage'},
        // { field: 'discountAddition', mask: 'percentage'},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["id"],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Condições comerciais desconto/acréscimo"
    },
    modelNamePlural: {
      type: String,
      default: "Condições comerciais desconto/acréscimo"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  created() {
    // this.loadServerEntries();
  },
  computed: {
    tableHeaders() {
      return [
        { text: "Descrição", align: "left", sortable: true, value: "description" },
        // { text: "Tabela preco", align: "left", sortable: false, value: "tablePrice.description" },
        // { text: "Cond. pagamento", align: "left", sortable: false, value: "paymentConditionRule.description" },
        { text: "Percentual", align: "left", sortable: true, value: "percent" },
        // { text: "Comissao", align: "left", sortable: true, value: "commission" },
        { text: "Tipo", align: "left", sortable: false, value: "percentTypeText" },
        { text: "Desconto acrescimo", align: "left", sortable: true, value: "discountAddition" },

        ... this.$can('create', this.$router.currentRoute.name) || this.$can('update', this.$router.currentRoute.name) ? [{ text: "Ações", align: "left", sortable: false, value: "action" }] : []
      ]
    }
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_TABLE_PRICE_ITEMS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.indexItems = response.data.accountContext.tablePriceItemsIndex.tablePriceItems; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.accountContext.tablePriceItemsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.tablePriceItemsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.tablePriceItemsIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const LOAD_ALL_TABLE_PRICE_ITEMS = gql `
  query($input: IndexInputObject!) {
    accountContext {
      tablePriceItemsIndex(input: $input){
        count
        typeOperators
        serverFields      
        tablePriceItems {
          id
          description
          percent
          percentType
          percentTypeText
          commission
          discountAddition
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`;

</script>

<style scoped></style>

